import React from 'react'
import { styled } from '@mui/material/styles'
import TextFormField from 'proposals/components/TextFormField'
import DynamicFieldBuilder from 'proposals/components/DynamicFieldBuilder'
import { Divider, Link, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const PREFIX = 'RequestForProposalForm'

const classes = {
  contactPerson: `${PREFIX}-contactPerson`,
  children: `${PREFIX}-children`
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme: { breakpoints, spacing } }) => ({
  [`& .${classes.contactPerson}`]: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing(2),
    marginBottom: spacing(1),
    marginTop: spacing(2),
    [breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr'
    }
  },

  [`& .${classes.children}`]: {
    marginBottom: spacing(2)
  }
}))

const ProposalForm: React.FC<{ fields: Field[]; rfpLang: string; children?: React.ReactNode, isPreview?: boolean }> = ({ fields, rfpLang, children, isPreview }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <div className={classes.contactPerson}>
        <TextFormField label={t('contact-first-name')} fullWidth name="person.firstName" disabled={isPreview} />
        <TextFormField label={t('contact-last-name')} fullWidth name="person.lastName" disabled={isPreview} />
        <TextFormField label={t('contact-email')} fullWidth name="person.email" required disabled={isPreview} />
        <TextFormField label={t('contact-phone')} fullWidth name="person.phone" disabled={isPreview} />
      </div>
      {!isPreview ? (
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          {t('without-contact-text')}
          <Link
            style={{ marginLeft: 3 }}
            component={RouterLink}
            rel="noopener noreferrer"
            to={`/privacy-policy?lang=${rfpLang}`}
            target="_blank"
            underline="hover"
          >
            {t('privacy-policy-2')}
          </Link>
          .
        </Typography>
      ) : (<Divider sx={{ my: 3 }} />)}
      <div className={classes.children}>{children}</div>
      {fields.map((field) => (
        <DynamicFieldBuilder key={field.id} field={field} disabled={isPreview} />
      ))}
    </Root>
  )
}

export default ProposalForm
